(function () {
  "use strict";

  XlsErrorCtrl.$inject = ['$scope'];
  angular
    .module('trainerWebApp.controllers')
    .controller('XlsErrorCtrl', XlsErrorCtrl);

  function XlsErrorCtrl($scope) {
    var xlsState = $scope.xlsState;

    function cellMapper(id) {
      var columnField = _.find(xlsState.userFields, function (field) {
        return field.id === id
      });
      if (!columnField) return angular.noop();
      var columnIdx = columnField.columnIdx;

      return function (row, cell, value, columnDef, item) {
        var txt = _.escape(item[columnIdx]) || '--';
        if (item.$errors && item.$errors[columnIdx])
          txt = '<div class="xls-err">' + txt + '<small>' + item.$errors[columnIdx] + '</small></div>';
        return txt;
      };
    }

    function errorFilterer(item) {
      return item.$errors;
    }

    var mapFieldToColumn = this.mapFieldToColumn = function (field) {
      return {
        id: field.id,
        name: _.escape(field.name),
        width: 200,
        headerCssClass: "header-column",
        sortable: false,
        formatter: cellMapper(field.id)
      };
    };

    $scope.gridInfo = {
      options: {
        editable: false,
        enableCellNavigation: false,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        multiColumnSort: true,
        rowHeight: 45
      },
      selectable: false,
      columns: [
        {id: "row", name: "Row", field: "id", width: 50, headerCssClass: "header-column", sortable: false}
      ].concat(_.map(xlsState.userFields, mapFieldToColumn)),
      filterFn: xlsState.hideGoodRowsOnError ? errorFilterer : undefined,
      data: xlsState.rows
    };

  }

})();
